import lodashSet from 'lodash.set';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/redux/store';
import { questionnairesApi } from 'app/services/questionnaires';

export type TForeignieNonUsInterestIncome = TForeignieNonUsInterestIncomeItem[];

export type TForeignieNonUsInterestIncomeItem = {
  nameOfPayer: Nullable<string>;
  grossInterest: Nullable<string>;
  taxWithheld: Nullable<string>;
};

export interface InterestStateValues {
  didReceiveAnyInterestIncomeDuringTheFilingYear: Nullable<string>;
  usInterestIncome: Nullable<string>;
  foreignieNonUsInterestIncome: TForeignieNonUsInterestIncome;
  nameOfPayer: Nullable<string>;
  grossInterest: Nullable<string>;
  currency: Nullable<string>;
  taxWithheld: Nullable<string>;
}

export interface InterestState {
  values: InterestStateValues;
}

const initialState: InterestState = {
  values: {
    didReceiveAnyInterestIncomeDuringTheFilingYear: null,
    usInterestIncome: null,
    foreignieNonUsInterestIncome: [
      { nameOfPayer: null, grossInterest: null, taxWithheld: null },
    ],
    nameOfPayer: null,
    grossInterest: null,
    currency: null,
    taxWithheld: null,
  },
};

const interestSlice = createSlice({
  name: 'interest',
  initialState,
  reducers: {
    update(state, action: PayloadAction<InterestStateValues>) {
      state.values = JSON.parse(JSON.stringify(action.payload));
    },
    updateKey(
      state,
      action: PayloadAction<{
        key:
          | keyof InterestStateValues
          | keyof TForeignieNonUsInterestIncomeItem;
        value: any;
      }>,
    ) {
      lodashSet(state, `values.${action.payload.key}`, action.payload.value);
    },
    updateFieldArrayKey(
      state,
      action: PayloadAction<{
        key:
          | keyof InterestStateValues
          | keyof TForeignieNonUsInterestIncomeItem;
        value: TForeignieNonUsInterestIncome;
      }>,
    ) {
      const fieldArray = action.payload.value.map((field) => ({ ...field }));
      if (action.payload.key === 'foreignieNonUsInterestIncome') {
        state.values[action.payload.key] = fieldArray;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      questionnairesApi.endpoints.getQuestionnaireById.matchFulfilled,
      (state, { payload }) => {
        state.values = payload.questionnaire.data.taxQuestionnaire
          ? payload.questionnaire.data.taxQuestionnaire.income.passiveIncome
              .interest.values
          : initialState.values;
      },
    );
  },
});

export const { update, updateKey, updateFieldArrayKey } = interestSlice.actions;
export default interestSlice.reducer;

export const selectInterest = (state: RootState) =>
  state.taxQuestionnaire.income.passiveIncome.interest;
